import { ge } from '../../utils/semver';
export var name = 'share';
export var supports = function (env) {
    return ((env.isInToutiao && ge(env.appVersion, '6.4.0')) ||
        env.isInVideo ||
        env.isInHotsoon);
};
